import { motion } from 'framer-motion';

export default function MapSection() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="relative"
    >
      <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
        <div className="w-full h-[420px]">
          <iframe
            title="Yangın Algılama Sistemleri Konum"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3059.5!2d32.8597!3d39.8753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d347e3e3e3e3e3%3A0x5e3e2b1c0d0e0f0a!2sKonutkent%20Mahallesi%2C%203028%20Cadde%2C%20%C3%87ankaya%2FAnkara!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full"
          />
        </div>

        <div className="p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-xl flex-shrink-0">
              <i className="ri-map-pin-line text-lg text-red-600"></i>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">
                Konutkent Mahallesi 3028 Cadde Elmar Towers C Blok No:17
              </p>
              <p className="text-xs text-gray-500">
                Çankaya / Ankara, Türkiye
              </p>
            </div>
          </div>
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Konutkent+Mahallesi+3028+Cadde+Elmar+Towers+C+Blok+No:17+Çankaya+Ankara"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white text-sm font-semibold rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-route-line text-sm"></i>
            Yol Tarifi Al
          </a>
        </div>
      </div>
    </motion.div>
  );
}
